//import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyA_n4Fr7BTYn_gxwzT9klIHnLke3x4-liU",
  authDomain: "farma-1ceee.firebaseapp.com",
  projectId: "farma-1ceee",
  storageBucket: "farma-1ceee.appspot.com",
  messagingSenderId: "352317402023",
  appId: "1:352317402023:web:abe520016fd5c87e3a2482"
};

// Initialize Firebase
//const app = initializeApp(firebaseConfig);
